import { breakpointValues } from 'pricing-pages-lib/constants/Breakpoints';
import { createContext, useContext, useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const IsMobileContext = /*#__PURE__*/createContext({
  isMobile: false
});
export const useIsMobile = () => {
  const {
    isMobile
  } = useContext(IsMobileContext);
  return isMobile;
};
const IsMobileContextProvider = ({
  children
}) => {
  const isWindowMobileWidth = () => window.innerWidth <= breakpointValues.tabletPortrait;
  const [isMobile, setIsMobile] = useState(isWindowMobileWidth());
  useEffect(() => {
    const mobileCheck = () => {
      if (isWindowMobileWidth() !== isMobile) setIsMobile(isWindowMobileWidth());
    };
    window.addEventListener('resize', mobileCheck);
    return () => {
      window.removeEventListener('resize', mobileCheck);
    };
  });
  const value = {
    isMobile
  };
  return /*#__PURE__*/_jsx(IsMobileContext.Provider, {
    value: value,
    children: children
  });
};
export default IsMobileContextProvider;